module.exports = __webpack_public_path__ + "static/img/5.3fa6d1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/zh/5.png
// module id = 3wnL
// module chunks = 0